import styled from 'styled-components';
import BaseInput from '../BaseInput';
import { InputProps } from 'antd';
import { Colors } from 'basic-ui-lib/constants';

const InputCentered = (props: InputProps) => {
  return (
    <Container>
      <StyledInput placeholder={props.placeholder} {...props} variant='borderless' />
    </Container>
  );
};

export default InputCentered;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 8px 16px;
  border-radius: 16px;
  background-color: ${Colors.neutral.bg[1]};
`;
const StyledInput = styled(BaseInput)`
  text-align: center;
  font-weight: 500;
  font-size: 28px;
  font-family: 'Poppins';

  &::placeholder {
    text-align: center;
    color: ${Colors.neutral.text[4]};
  }
`;
